import { useState } from 'react'
import {
  Modal,
  Button,
  Form,
  Spinner,
  Row,
  Col,
} from 'react-bootstrap'
import { toast } from 'components/common/Toast';
import { connect } from 'react-redux'
import config from 'config'
import { useTranslation, Trans } from 'react-i18next'
import i18n from 'config/i18n'

import NumberFormat from 'react-number-format'
import { UserServices } from 'services'
import { setUser } from 'actions/connection';
import { setRegisterModal, setMainContent,
  setIsFullScreen
} from 'actions';
import {
  FamaleTierWrapper,
  Question,
  QuestionContent,
  Bonus,
  AccountStatus,
  AccountStatusTitle,
  AccountStatusCount,
  AccountStatusWarning,
  AccountStatusItem,
  DownloadContainer,
  DownloadIos,
  DownloadAndroid,
  FeeDescription,
  StoryAction,
  StoryContainer,
  Text,
  FemaleBox
} from './style'
import { TierModal, Referral } from 'components/common';
import { QuestionCircle } from 'assets/icons/components'
import { setActiveSidebar } from 'actions/mainContent';
import { RecentCalls, Select, StoryModal } from 'components//common/index';

const FemaleMonetizationBox = (props) => {
  const { t } = useTranslation('live', { i18n })
  const { user, dispatch } = props
  const { balance } = user
  const [isExpandPremium, setIsExpandPremium] = useState(false)
  const [isShowWithdrawModal, setIsShowWithdrawModal] = useState(false)
  const [isLoadingWithdraw, setIsLoadingWithdraw] = useState(false)
  const [isShowReferral, setIsShowReferral] = useState(false)
  const [isShowStoryModal, setIsShowStoryModal] = useState(false)
  const [inputValues, setInputValues] = useState({
    address: '', method: 'USDT', first_name: '', last_name: '',
  })
  const [isShowTierModal, setIsShowTierModal] = useState(false)
  const [labels, setLabels] = useState({
    // Paxum: t('Paxum Email'),
    Bitcoin: t('Bitcoin address'),
    Epayservices: t('EUR Wallet Number'),
    Card: 'Card number',
    USDT: t('Address'),
    BUSD: t('Address')
  })

  const [placeholders, setPlaceholders] = useState({
    // Paxum: t('Paxum Email'),
    Bitcoin: t('Bitcoin address'),
    Epayservices: t('EUR Wallet Number'),
    Card: 'Card number',
    USDT: 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t',
    BUSD: '0xdac17f958d2ee523a2206206994597c13d831ec7'
  })

  const handleOpenModal = () => {
    if (user?.role === 'guest') {
      dispatch(setRegisterModal(true))
      return;
    }

    if (user?.monetization_status !== 3) {
      dispatch(setMainContent('monetization'))
      dispatch(setIsFullScreen(false))
      return;
    }

    setIsShowWithdrawModal(true)
  }

  const handleCloseModal = () => {
    setIsShowWithdrawModal(false)
  }

  const handleOnChange = event => {
    const value = event.target.value
    const id = event.target.id
    setInputValues({ ...inputValues, [id]: value })
  }

  const handleOpenTier = () => {
    if (user?.role === 'guest') {
      dispatch(setRegisterModal(true))
      return;
    }

    if (user?.monetization_status !== 3) {
      dispatch(setMainContent('monetization'))
      dispatch(setIsFullScreen(false))
      return;
    }

    setIsShowTierModal(true)
  }

  const handleWithdraw = async () => {
    setIsLoadingWithdraw(true)

    const { error } = await UserServices.withdraw(inputValues)

    if (!error) {
      toast.success(t('Your withdraw has been submited'))
      handleCloseModal()

      let cloneUser = JSON.parse(JSON.stringify(user))
      cloneUser.balance = 0

      dispatch(setUser(cloneUser))
    } else {
      toast.error(t(error?.response?.data.message))
    }

    setIsLoadingWithdraw(false)
  }

  const onClickStatus = () => {
    if (user?.role === 'guest') {
      dispatch(setRegisterModal(true))
      return;
    }

    dispatch(setActiveSidebar('settings'))
    dispatch(setMainContent('monetization'))
    dispatch(setIsFullScreen(false))
  }

  const onChangeContent = (tab) => {
    dispatch(setMainContent(tab))
    dispatch(setIsFullScreen(false))
  }

  return (
    <>
      <div className={`dashboard__premium`}>
        <div className="dashboard__premium-container">
          {/* <div
            className='premium__user'
            onClick={() => setIsExpandPremium(!isExpandPremium)}>
            <div
              className='user__avatar'
              style={{ backgroundImage: `url(${user?.avatar})` }}>
            </div>
            <div className='user__info'>
              <div className='info__username'>
                {user?.name}
              </div>
              <div className='info__status' onClick={() => onClickStatus()}>
                {user?.monetization_status === 3 ?
                  <div className='status__premium-status status__premium-status--verified'>
                    { t('Verified') }
                  </div>
                  : user?.monetization_status === 2 ?
                    <div className='status__premium-status status__premium-status--verifying'>
                      { t('Verifying') }
                    </div>
                  : user?.monetization_status === 1 ?
                    <div className='status__premium-status status__premium-status--verifying'>
                      { t('Upload document') }
                    </div>
                  : <div className='status__premium-status status__premium-status--guest'>
                    { t('Free') }
                    </div>}
              </div>
            </div>
          </div> */}
          {/* { user?.monetization_status === 3
            ?
              <>
                <div className='premium__header'>
                  <div className='header__title'>
                    { t('Account Balance')}
                  </div>
                </div>
                <div className='premium__info'>
                  <div className='info__wrapper __withdraw' onClick={() => handleOpenModal()}>
                    <div className='wrapper__left points'>
                      <div className='left__figure left__figure--point'>
                        {Math.floor(user?.balance)}
                      </div>
                      <div className='left_title'>
                        { t('Points') }
                      </div>
                    </div>
                    <div className='wrapper__left balance'>
                      <div className='left__figure left__figure--point'>
                        <NumberFormat value={user?.balance * 0.01} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale="2" />
                      </div>
                    </div>
                  </div>
                  <FamaleTierWrapper className='info__wrapper' onClick={() => handleOpenTier()}>
                    <div className='wrapper__left'>
                      <div className='left__figure'>
                        <Question>
                          <QuestionCircle/>
                          <QuestionContent>
                            <p>{t('Points for the first and subsequent minutes')}</p>
                          </QuestionContent>
                        </Question>
                      </div>
                      <div className='left_title'>
                        { t('Tier') }
                      </div>
                    </div>
                  </FamaleTierWrapper>
                </div>
              </>
            :<></>
          } */}
        </div>

        {/* { !mobile() && <RecentCalls /> } */}
        {
          user?.monetization_status !== null
          ?
            <FemaleBox className="dashboard__premium-container">
              <AccountStatus>
                <AccountStatusTitle>
                  {t('Story')}
                  <Question onClick={() => setIsShowStoryModal(true)} onTouchEnd={() => setIsShowStoryModal(true)}>
                    <QuestionCircle/>
                  </Question>
                </AccountStatusTitle>
                <StoryContainer>
                  <Text>{ t('Get more points for likes and enhance visibility among Premium users.') }</Text>
                  <StoryAction onClick={() => onChangeContent('story')} onTouchEnd={() => onChangeContent('story')}>
                    {t('Add a short video')}
                  </StoryAction>
                </StoryContainer>
              </AccountStatus>
            </FemaleBox>
          : <></>
        }
        
        {
          user?.reports && user?.reports.length 
          ?
            <div className="dashboard__premium-container">
              <AccountStatus>
                <AccountStatusTitle>{t('Account status')}</AccountStatusTitle>
                <AccountStatusCount>{t('{{count}} out of {{total}} warnings.', { count: user?.reports.length , total: 3 })}</AccountStatusCount>
                { 
                  user?.reports.map((reason, index) => <AccountStatusItem key={reason + index}>- { reason }</AccountStatusItem>)
                }
                
                <AccountStatusWarning>{t('Multiple warnings may result in temporary or permanent account ban')}</AccountStatusWarning>
              </AccountStatus>
            </div>
          : 
            <></>
        }
      </div>
      <StoryModal isShow={isShowStoryModal} closed={() => setIsShowStoryModal(false)} />
    </>
  )
}

const mapStateToProps = (state) => ({
  user: state.connectionReducer.user
})

export default connect(mapStateToProps)(FemaleMonetizationBox)